import { isValidDateString } from "../js/utils";

// <input type="date"> que, al perder el foco, vacía las fechas inexistentes
// (p. ej. 31/09) o fuera de rango en lugar de dejarlas a medias en pantalla
export default function DateInput({ onChange, onBlur, ...props }) {
  return (
    <input
      max="9999-12-31"
      {...props}
      type="date"
      onChange={onChange}
      onBlur={(e) => {
        const input = e.target;
        if (
          input.validity.badInput ||
          (input.value !== "" && !isValidDateString(input.value))
        ) {
          input.value = "";
          onChange?.({ target: { value: "" } });
        }
        onBlur?.(e);
      }}
    />
  );
}
